<template>
  <div class="product fs-16 product-center">
    <div class="cont">
      <component v-for="(o, i) in dataList" :key="i" :is="componentMap[o.moduleType]" :info="o"></component>
    </div>
  </div>
</template>

<script>
import NavTab from './component/navTab.vue'
import NewProduct from './component/newProduct.vue'
import Consulting from './component/consulting.vue'
import Advantage from './component/advantage.vue'
import ImgCarousel from './component/imgCarousel.vue'
export default {
  components: { NavTab, NewProduct, Consulting, Advantage, ImgCarousel },
  data () {
    return {
      componentMap: ['NavTab', 'NewProduct', 'Consulting', 'Advantage', 'ImgCarousel'], // 0-导航，1-上新，2-咨询，3-优势，4-轮播
      dataList: []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.API.product.getProductCenter({
        centerType: 2
      }).then((res) => {
        this.dataList = res.data || []
      })
    }
  }
}
</script>
